<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 768 768" xml:space="preserve">
        <g>
            <path class="racing-stars-icon" d="M764.07,297.97l-262.81-38.04L383.61,21.84L266.23,260.05L3.46,298.38l190.25,185.25l-44.74,261.74
		L383.9,621.73l235.13,123.4l-45.01-261.71L764.07,297.97z M385.82,436.96c2.06-4.67,6.89-7.49,11.96-6.99l-8.17-41.6
		c-18.58,2.39-34.57,14.32-42.16,31.45c-8.47,19.05-5.26,41.28,8.25,57.16l10.36,10.21l-2.78,97.91l-158.54,83.46l31.75-185.78
		c32.21-69.69,102.57-115.21,183.52-119.99l-0.64,20.13l22.38,119.92l-54.56-53.75C384.56,445.59,384.03,440.95,385.82,436.96z
		 M405.31,585.44l1.64-57.93l32.89,32.43l49.29-32.23l-27.64-147.98l1.91-58.66l-21.11-0.6c-97.03-2.75-184.86,44.02-231.51,121.13
		L93.78,327.67l200.36-29.24l89.58-181.65l89.71,181.55l200.39,29.02L528.89,468.8l34.34,199.57L405.31,585.44z" />
        </g>
    </svg>
</template>

<style type="text/css">
	
</style>